
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 6.82c.573 0 1.237.078 1.992.235C7.164 7.784 6.5 8.747 6.5 9.945v1.875H.68V9.75c0-.599.351-1.133 1.054-1.602a7.75 7.75 0 012.383-1.015c.86-.209 1.654-.313 2.383-.313zm3.242 1.485c1.042-.417 2.044-.625 3.008-.625.963 0 1.966.208 3.008.625 1.041.416 1.562.963 1.562 1.64v1.875H8.18V9.945c0-.677.52-1.224 1.562-1.64zM8.258 4.438c-.495.494-1.08.742-1.758.742-.677 0-1.263-.248-1.758-.742C4.247 3.942 4 3.357 4 2.68s.247-1.263.742-1.758C5.237.427 5.822.18 6.5.18c.677 0 1.263.247 1.758.742.495.495.742 1.08.742 1.758 0 .677-.247 1.263-.742 1.757zm5.937.976c-.39.39-.872.586-1.445.586a2.097 2.097 0 01-1.484-.586 2.097 2.097 0 01-.586-1.484c0-.573.195-1.068.586-1.485a2.028 2.028 0 011.484-.625c.573 0 1.055.209 1.445.625.417.417.625.912.625 1.485 0 .573-.208 1.067-.625 1.484z","fill":"currentColor"}})])
          )
        }
      }
    